import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-spotlight-full-page-loader',
  templateUrl: './spotlight-full-page-loader.component.html',
  styleUrls: ['./spotlight-full-page-loader.component.css']
})
export class SpotlightFullPageLoaderComponent implements OnInit {

  @Input() page:any;
  background:string;
  text:string;
  constructor() { }

  ngOnInit(): void {
    if(this.page == 'redcarpet'){
      this.background = "assets/images/cinejoy/loader_background_redcarpet.png";
      this.text = "Rolling out the red carpet...";
    }else if (this.page === "theaterPage") {
      this.background = "assets/images/cinejoy/loader_background_theater.png";
      this.text = "Spooling the film reel...";
    } else if (this.page === "celebrationsalon") {
      this.background ="assets/images/cinejoy/loader_background_celebration_salon.png";
      this.text = "Setting the stage...";
    }else if(this.page === 'groupsharing'){
      this.background = "assets/images/cinejoy/loader_background_redcarpet.png";
      this.text = "Rolling out the Group Sharing...";
    }

  }


}
